document.addEventListener('click', function (e) {
  var backBtn = e.target.closest('[data-cif-back]');
  if (!backBtn) return;

  var success = backBtn.closest('[data-cif-success]');
  if (!success) return;

  success.hidden = true;

  var url = new URL(window.location.href);
  url.searchParams.delete('contact_posted');
  history.replaceState(null, '', url.pathname + url.search);
});

function updateCifSubmitState(body) {
  var inputs = Array.from(body.querySelectorAll('input, textarea'));
  var isValid = inputs.every(function (input) { return input.checkValidity(); });
  var submitBtn = body.querySelector('.contact-info-form__cf-submit');
  if (submitBtn) submitBtn.classList.toggle('is-valid', isValid);
}

document.addEventListener('input', function (e) {
  var body = e.target.closest('.contact-info-form__cf-body');
  if (body) updateCifSubmitState(body);
});

document.addEventListener('change', function (e) {
  var body = e.target.closest('.contact-info-form__cf-body');
  if (body) updateCifSubmitState(body);
});
